export default __webpack_public_path__ + "static/fuel-tanker-69a04d95837f3e53d0dac356db55d12f.jpg";